<template>
  <div>
    <a href="#" @click="closeForm" class="add-new-address">{{ '< BACK' }}</a>
    <div class="communication-form">
        <div class="col-md-12">
          <ValidatedInput
            name="address_info_1"
            label="Flat, House Number, Building, Apartment:"
            type="text"
            placeholder="Flat,House,Building Apartment"
            successMessage=""
            v-model="fields.addressInfo1"
            :success=false
            :showSuccessIcon=false
            :required="true"
            />
        </div>
        <div class="col-md-12">
          <ValidatedInput
            name="address_info_2"
            label="Area, Street, Sector,Village:"
            type="text"
            placeholder="Area,Street,Sector,Village"
            successMessage=""
            v-model="fields.addressInfo2"
            :success=false
            :showSuccessIcon=false
            :required="true"
          />
        </div>
  
      <!-- <div class="row"> -->
        <div class="col-md-12">
          <ValidatedInput
            name="landmark"
            label="Landmark:"
            type="text"
            placeholder="Landmark"
            successMessage=""
            v-model="fields.landmark"
            :success=false
            :showSuccessIcon=false
            :required="false"
          />
        </div>
        <div class="col-md-12" style="position: relative">
          <ValidatedInput
            name="pincode"
            label="Pincode"
            type="text"
            :minlength="6"
            :maxlength="6"
            validationType="numbers-only"
            placeholder="Pincode"
            successMessage=""
            v-model="fields.pincode"
            @input="searchPincode"
            :success=false
            :showSuccessIcon=false
            :required="true"
          />
          <!-- <ul v-if="pincodeOptions.length==0" class="dropdown-menu">
        <li>No Pincode Found</li>
      </ul> -->
      <ul v-if="toggleLocationDropdown" class="pincodeOptions">
        <li v-if="pincodeOptions.length==0">No Pincode Found</li>
              <li v-else
                v-for="option in pincodeOptions"
                :key="option.id"
                :value="option.pincode"

                @click="selectLocation(option)"
              >
                {{ option.pincode }}-{{ option.city }}-{{ option.statename }}
              </li>
            </ul>
        </div>
      <!-- </div> -->
      <!-- <div class="row"> -->
        <div class="col-md-12">
          <ValidatedInput
      name="state"
      label="State:"
      type="text"
      placeholder="State"
      successMessage=""
      validationType="no-numbers"
      v-model="fields.state"
      autocomplete="off"
      :disabled="true"
      :success=false
      :showSuccessIcon=false
      :required="true"
    />
        </div>
        <div class="col-md-12">
          <ValidatedInput
      name="city"
      label="Town/City:"
      type="text"
      validationType="no-numbers"
      placeholder="City"
      successMessage=""
      v-model="fields.city"
      autocomplete="off"
      :disabled="true"
      :success=false
      :showSuccessIcon=false
      :required="true"
    />
        </div>
      <!-- </div> -->
    </div>
    <button
     class="btn add_btn"
     style="position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);"
     @click="createAddress"
     :disabled="!isFormValid"
    >
    {{ loading ? 'Please Wait...' : "" }}
    {{ !loading?fields?.id
    ? 'Update' 
    : 'Add':""
    }}
    </button>
  </div>
</template>
<script setup>
import ValidatedInput from "@/components/common/CustomInput.vue"
// import { useFormValidation } from "@/composables/userFormValidation";
import useAuthenticatedApi from "@/plugins/useAuthenticatedApi";
import { useUserStore } from "@/stores/userStore";
import eventBus from '@/utils/eventBus';
import { showToast } from "@/utils/toaster";
import { computed, ref,reactive ,watch} from "vue";
import { useUsers } from '@/composables/useUsers'

const props = defineProps({
  address: {
    type: Object,
    default: null,
  },
});


const fields= reactive({
  addressInfo1:'',
  addressInfo2:'',
  landmark:'',
  pincode:'',
  city:'',
  state:'',
  id:"",
});
const loading = ref(false);


const rules = {
  addressInfo1: value => (!value ? 'Flat, House Number, Building, Apartment Information is required' : null),
  addressInfo2: value => (!value ? 'Area, Street, Sector,Village Information is required' : null),
  // landmark: value => (!value ? 'Landmark is required' : null),
  pincode: value => (!value||(value&&value.toString().length<6) ? 'Pincode is required' : null),
  city: value => (!value ? 'City is required' : null),
  state: value => (!value ? 'State is required' : null),
};


const errors = ref({});
  const isFormValid = ref(false);

  function validateForm() {
    errors.value = {};

    // Validate each field according to its rules
    for (const field in fields) {
      if (rules[field]) {
        const error = rules[field](fields[field]);
        if (error) {
          errors.value[field] = error;
        }
      }
    }

    // Check if the form is valid
    isFormValid.value = Object.keys(errors.value).length === 0;
  }

  // Watch for changes in field values and validate form
  watch(
    fields,  // Watch the fields directly
    () => validateForm(),
    { deep: true, immediate: true }
  );

// Watch for changes in the initialAddressData prop and update only the whitelisted fields
watch(
  () => props.address,
  (newAddress = {}) => {
    if (newAddress) {
    fields.addressInfo1 = newAddress.value?.address1 || "";
    fields.addressInfo2 = newAddress.value?.address2 || "";
    fields.landmark = newAddress.value?.landmark || "";
    fields.pincode = newAddress.value?.pincode || "";
    fields.city = newAddress.value?.city || "";
    fields.state = newAddress.value?.state || "";
    fields.id = newAddress.value?.id || "";
    validateForm();
    }
  },
  { immediate: true,deep:true } // Ensure the watcher runs immediately and deeply
);



watch(fields, () => {
  validateForm();
},{deep:true});
const toggleLocationDropdown = ref(false);
const pincodeOptions = ref([]);

const { addressService } = useAuthenticatedApi();
const userStore = useUserStore();
const mca_no = computed(()=>userStore.mcano);

async function createAddress(){
  try {
    validateForm()
    if(!isFormValid.value)return;
    const payload = {
      address1: fields.addressInfo1,
      address2: fields.addressInfo2,
      "street": "",
      "landmark": fields.landmark,
      "pincode": fields.pincode,
      "city": fields.city,
      "state": fields.state,
      "mca_no": mca_no.value
    }
    loading.value = true
    if(props.address.value?.id){
      const result = await addressService.updateAddressItem(props.address.value?.id,payload);
      console.log(result.data);
    }else{
      const result = await addressService.createAddressItem(payload);
      console.log(result.data);
    }
  } catch (error) {
    console.log(error)
    showToast("error")
  }
  loading.value = false
  closeForm()
}

function selectLocation(code){
 if(code){
    fields.pincode = code?.pincode;
    fields.state = code?.statename;
    fields.city = code?.city;
    toggleLocationDropdown.value = false;
  }
}
// const axios = inject('axios');
const { fetchShippingPincode } = useUsers();
async function searchPincode(){
    const searchValue = fields.pincode;
    try {
    // Check if the input is not empty
        if (searchValue?.toString().length > 3) {
          try {
      // Call the fetchShippingPincode function (assuming it's an async function)
      const response = await fetchShippingPincode(searchValue);

      // Update the dropdown and options if the response is valid
      toggleLocationDropdown.value = false;
      pincodeOptions.value = [];
      console.log(response);
      pincodeOptions.value = response; // Ensure this structure matches your API response
      toggleLocationDropdown.value = true;
      
    } catch (error) {
      // Handle error while fetching pincodes
      console.error("Error fetching pincodes:", error);
      toggleLocationDropdown.value = false; // Ensure dropdown is hidden in case of error
    }
        } else {
            toggleLocationDropdown.value = false;
            // Clear options if the input is empty
            pincodeOptions.value = [];
        }
    } catch (error) {
        console.log(error);
    }
}

function closeForm(){
  if(eventBus.panelOpen){
    eventBus.panelOpen("Change Address");
  }
}
</script>
<style scoped>
*{
  text-align: left;
}
.communication-form{
  margin-top: 20px;
}
button{
  background-color: #00306c;
  color: #fff;
  border-radius: 5px;
  margin: 15px!important;
  width: 200px;
}
button:hover{
  color: white;
}
a {
  margin: 5px;
  margin-left: 15px;
  color: #00306c;
}
.pincodeOptions {
  position: relative;
  display: inline-block;
}

.pincodeOptions {
  display: block;
    position: absolute;
    /* overflow: scroll; */
    background-color: white;
    border: 1px solid #ccc;
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top:-20px;
    max-width: 393px;
    border-radius:0 0 5px 5px;
    /* width: 335px; */
    z-index: 9;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
}

.pincodeOptions li {
  padding: 8px;
  cursor: pointer;
  background-color: white;
  z-index: 1;

}

.pincodeOptions li:hover {
  /* background-color: #f0f0f0; */
}
</style>